module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Light.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Light.eot
// module id = 17
// module chunks = 8